import {
  useCallback,
  useMemo
} from 'react';

import { useValidatePromoCodeLazyQuery } from 'generated/graphql';



export function useValidatePromoCode() {
  const [
    fnQuery,
    tuple
  ] = useValidatePromoCodeLazyQuery({
  });

  const fnWrappedMutate = useCallback(
    async (code: string) => {
      const result = await fnQuery({
        variables: {
          code
        }
      });

      return result.data?.validatePromoCode ?? false;
    },
    [fnQuery]
  );

  return useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
